// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lmFp","question":"styles_question__14CLA","description":"styles_description__3Aemi"};